import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import CreateReportModal from './CreateReportModal';
import { generateReportInitiate } from '../../../actions/reports';

const mapStateToProps = state => {
  const reportID = _get(state, 'reports.generateReportDetails.report_id', '');
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const groupsData = _get(state, 'groups', {});
  const invoiceData = _get(state, 'company.invoiceData', {});
  const isBulkOrderInvoicesEnabled = _get(
    state,
    'user.supported_features.bulk_order_invoices_enabled',
    true,
  );
  const mappedOffices = _get(state, 'company.mappedOffices', {});
  return {
    invoiceData,
    mappedOffices,
    reportID,
    groupsData,
    selectedWorkspace,
    initiatingReport:
      _get(state, 'apiState.GENERATE_REPORT.isFetching', false) &&
      !_get(state, 'apiState.GENERATE_REPORT.isIdle', true),
    initiatedReport: _get(state, 'apiState.GENERATE_REPORT.success', true),
    isBulkOrderInvoicesEnabled,
  };
};

const mapDispatchToProps = dispatch => ({
  generateReport: payload => dispatch(generateReportInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateReportModal);
